import React, { useEffect } from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

const Section = tw.section`bg-white py-16 px-4 md:px-20 text-center -mx-8 -mt-8`;
const Description = tw.p`text-gray-600 max-w-xl mx-auto mb-6 leading-relaxed mt-8`;
const SocialText = tw.p`text-gray-800 font-medium mb-8`;
const EmbedWrapper = tw.div`max-w-xl mx-auto`;

const InstagramEmbed = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.setAttribute("src", "https://www.instagram.com/embed.js");
        script.setAttribute("async", "");
        document.body.appendChild(script);
    }, []);

    return (
        <Section>
            <HeadingTitle>Redes Sociales</HeadingTitle>
            <Description>
                Conectate con nuestro día a día: hornos prendidos, recetas en acción y comunidad panadera.
            </Description>
            <SocialText>
                Seguinos en <span tw="text-blue-600 font-semibold">@panificadosmylen</span> en Instagram y Facebook
            </SocialText>

            <EmbedWrapper>
                <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/panificadosmylen/"
                    data-instgrm-version="14"
                    style={{ width: "100%", margin: "auto" }}
                ></blockquote>
            </EmbedWrapper>
        </Section>
    );
};

export default InstagramEmbed;
